var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 972,
    height: 916,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.624 916h91.235C1233.71 916 1439 709.901 1439 457.995 1439 206.088 1233.72 0 982.859 0H0l105.337 183.2h877.522c150.511 0 273.681 123.67 273.681 274.795 0 151.124-123.16 274.805-273.681 274.805h-91.235V916zM210.685 366.4l105.337 183.2h210.685V916h182.459V549.6h364.914V366.4H210.685z",
    fill: "#F7F8F9"
  })));
}

export default SvgBgMain;